<template>
  <div>
    <div class="section" v-if="isNoP === false"></div>
    <div class="section1" v-if="isNoP === true"></div>
  </div>
</template>
<script>
export default {
  props: ["isNoP"],
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  watch: {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  background-image: url("~@/views/CNBM/images/contents.png");
  background-repeat: no-repeat;
  background-size: cover;
  height: 1124px; //A4纸的高度像素
  overflow: hidden;
  padding-top: 130px;
}
.section1 {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  background-image: url("~@/views/CNBM/images/contents-noP.png");
  background-repeat: no-repeat;
  background-size: cover;
  height: 1124px; //A4纸的高度像素
  overflow: hidden;
  padding-top: 130px;
}
</style>




// WEBPACK FOOTER //
// src/views/CNBMTalent/pages/contents.vue